import { render, staticRenderFns } from "./NacexAccounts.vue?vue&type=template&id=490bae8e&scoped=true"
import script from "./NacexAccounts.vue?vue&type=script&lang=js"
export * from "./NacexAccounts.vue?vue&type=script&lang=js"
import style0 from "./NacexAccounts.vue?vue&type=style&index=0&id=490bae8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490bae8e",
  null
  
)

export default component.exports